<template>
  <f7-page>
    <f7-navbar v-bind:title="courseName" back-link="Back">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <header class="wave-header sticky-top">
      <div class="course-content">
        <f7-row>
          <div
            class="avatar"
          ></div>
          <div class="name">
            <h3>{{ name }}</h3>
            <p>
              <span>選課代碼 {{ courseCode }}</span>
              <!--
              <span>・</span>
              <span>課程代號 1131</span>
              -->
            </p>
          </div>
        </f7-row>
      </div>
    </header>

    <!-- 老師的 -->
    <template v-if="applyStatus==10">
      <div class="list medium-detail-content">
        <ul>
          <li class="item-content">
            <div class="item-inner hint">請至 email 確認受輔者詳細輔導訊息，如上課時間、地點、教材工具...等。</div>
          </li>
          <li>
          <input id="medium-agree" type="radio" name="agreement" value="agree" @click="optionChange(30)" checked />
          <label class="item-radio item-content" for="medium-agree" @click="optionChange(30)">
            <i class="icon icon-radio"></i>
            <div class="item-inner">
              <div class="item-title">已確認無誤，開始上課</div>
            </div>
          </label>
          <div class="item-inner item-content ">
            <div class="item-input-wrap">
              <textarea class="resizable filled" placeholder="請填寫授課預定內容" v-model="reason2"></textarea>
              <span class="input-clear-button"></span>
            </div>
          </div>
        </li>
          <li class="item-input item-input-outline">
          <input id="medium-disagree" type="radio" name="agreement" value="disagree" @click="optionChange(80)"/>
          <label class="item-radio item-content" for="medium-disagree" @click="optionChange(80)">
            <i class="icon icon-radio"></i>
            <div class="item-inner">
              <div class="item-title">未達共識，婉拒此學生</div>
            </div>
          </label>
          <div class="item-inner item-content ">
            <div class="item-input-wrap">
              <textarea class="resizable filled" placeholder="請告訴我們原因" v-model="reason"></textarea>
              <span class="input-clear-button"></span>
            </div>
          </div>
        </li>

          
        </ul>
        <f7-button class="button-large" @click="confirmData()">送出</f7-button>
      </div>
    </template>


  </f7-page>
</template>

<script>
import Service from "../../../service";
import axios from '../../../js/axiosModule.js';
import { bus } from '../../../js/bus';

export default {
  components: {},
  data() {
    return {
      dish: Service.getDish(this.$f7route.params.id),
      name:this.$store.state.userInfo.chineseName,
      id:'',
      setYear:'',
      setTerm:'',
      tutor:'',
      tutee:'',
      courseCode:'',
      courseName:'',
      applyStatus:'',
      courseEndAt:'',
      note:'',
      searchTerm:'',
      createdBy:'',
      createdAt:'',
      updatedBy:'',
      updatedAt:'',
      statusChange:30,
      reason:'',
      reason2:'',
      loadingFlag:false
    };
  },

  created: function() {
    let self = this;
    bus.$on('detail-teacher',function(res){
      self.loadingFlag = true;
      self.id = res.id;
      self.setYear = res.setYear;
      self.setTerm = res.setTerm;
      self.tutor = res.tutor;
      self.tutee = res.tutee;
      self.courseCode = res.courseCode;
      self.courseName = res.courseName;
      self.applyStatus = res.applyStatus;
      self.courseEndAt= res.courseEndAt;
      self.note = res.note;
      self.searchTerm = res.searchTerm;
      self.createdBy = res.createdBy;
      self.createdAt = res.createdAt;
      self.updatedBy = res.updatedBy;
      self.updatedAt = res.updatedAt;
      self.loadingFlag = false;
    });
  },
  mounted() {},
  methods: {
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    },
    optionChange:function(status) {
      this.statusChange = status;
    },
    confirmData:function() {
      let self = this;
      var params = {};
      params.id = self.id;
      params.setYear = self.setYear;
      params.setTerm = self.setTerm;
      params.tutor = self.tutor;
      params.tutee = self.tutee;
      params.courseCode = self.courseCode;
      params.courseName = self.courseName;
      params.applyStatus = self.statusChange;
      params.courseEndAt= self.courseEndAt;
      if (this.statusChange == 30) {
          params.note = self.reason2;
      }else {
          params.note = self.reason;
      }      
      params.searchTerm = self.searchTerm;
      params.createdBy = self.createdBy;
      params.createdAt = self.createdAt;
      params.updatedBy = self.updatedBy;
      params.updatedAt = self.updatedAt;
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/UpdateCoachApplyCourseStatus",params).then((response)=> {
        if(response.data.status == 200) {
           window.localStorage.removeItem("transferKey");
           this.$f7router.navigate("/coursework");
        } else {
          alert("fail!");
        }
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/medium/medium-detail-teacher.vue